import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withKeys as _withKeys, withCtx as _withCtx, unref as _unref } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "tw-flex tw-justify-between tw-items-center"
}
const _hoisted_2 = { class: "tw-flex tw-items-center" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "tw-flex tw-items-center" }
const _hoisted_5 = {
  key: 1,
  class: "role-container tw-flex tw-justify-between tw-items-center"
}
const _hoisted_6 = { class: "role-inner tw-flex tw-gap-[5px]" }

import VRuntimeTemplate from "vue3-runtime-template";
import { IDropDownData } from "@/interfaces/common/IDropDown";
import { PropType, ref, watch } from "vue";
import store from "@/store";
import { OVERLAY_KEYBOARD } from "@/utils/constants";
import ArrowDownTableIcon from "@/components/svgs/arrowDownTableIcon.vue";
type ITypeProps = "single" | "multi-select" | "role-item";


export default /*#__PURE__*/_defineComponent({
  __name: 'customBDropDown',
  props: {
  id: { type: String, required: true },
  className: { type: String, required: false, default: "" },
  classTextName: { type: String, required: false, default: "" },
  classTextPlaceholder: { type: String, default: "" },
  placeholder: { type: String, default: "" },
  validation: { type: Object, default: () => ({}) },
  showInfo: { type: Boolean, default: false },
  data: {
    type: Array as PropType<IDropDownData[]>,
    required: true,
    default: () => [],
  },
  type: { type: String as PropType<ITypeProps>, default: "single" },
  disabled: { type: Boolean, default: false },
  arrowColor: { type: String, default: "#387DFF" },
  dataCyId: { type: String, default: "" },
},
  emits: [
  "update:moveSelectionDown",
  "update:showDrop",
  "update:enterValue",
  "update:moveSelectionUp",
],
  setup(__props, { emit }) {

const props = __props;

const isDropdownOpen = ref(false);


const moveSelectionDown = (step) => {
  emit("update:moveSelectionDown", step);
};
const moveSelectionUp = (step) => {
  emit("update:moveSelectionUp", step);
};

const showDropdow = () => {
  emit("update:showDrop");
  store.commit("keyBoard/SET_ENTER", OVERLAY_KEYBOARD.DROPDOWN);
};

const selectItem = (event) => {
  if (event.key == "ArrowDown") {
    isDropdownOpen.value = true;
    store.commit("keyBoard/SET_ENTER", OVERLAY_KEYBOARD.DROPDOWN);
  }
  if (event.key == "Enter") {
    emit("update:enterValue");
    isDropdownOpen.value = false;
    setTimeout(() => {
      store.commit("keyBoard/SET_ENTER", OVERLAY_KEYBOARD.MODAL);
    }, 1000);
  }
};

watch(isDropdownOpen, (newValue, oldValue) => {
  if (!newValue && oldValue) {
    setTimeout(() => {
      store.commit("keyBoard/SET_ENTER", OVERLAY_KEYBOARD.MODAL);
    }, 1000);
  }
});

return (_ctx: any,_cache: any) => {
  const _component_b_dropdown = _resolveComponent("b-dropdown")!
  const _component_b_form_invalid_feedback = _resolveComponent("b-form-invalid-feedback")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_b_dropdown, {
      id: props.id,
      modelValue: isDropdownOpen.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((isDropdownOpen).value = $event)),
      class: _normalizeClass([
      'custom-dropdown',
      props.className,
      props.validation.$error ? 'invalid' : '',
      __props.disabled && 'tw-pointer-events-none tw-opacity-50',
    ]),
      "data-cy": __props.dataCyId,
      onKeydown: [
        _cache[1] || (_cache[1] = _withKeys(($event: any) => (moveSelectionDown(1)), ["down"])),
        selectItem,
        _cache[2] || (_cache[2] = _withKeys(($event: any) => (moveSelectionUp(-1)), ["up"]))
      ],
      onShow: showDropdow
    }, {
      "button-content": _withCtx(() => [
        _renderSlot(_ctx.$slots, "button-content", {}, () => [
          (props.type === 'single')
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  (props.data[0] && props.data[0]?.iconSrc)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        class: "tw-mr-[5px]",
                        src: props.data[0]?.iconSrc || ''
                      }, null, 8, _hoisted_3))
                    : _createCommentVNode("", true),
                  (props.data[0])
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 1,
                        class: _normalizeClass(`tw-text-[#231F20] ${__props.classTextName}`)
                      }, _toDisplayString(props.data[0]?.name), 3))
                    : (_openBlock(), _createElementBlock("span", {
                        key: 2,
                        class: _normalizeClass(`placeholder-container ${__props.classTextPlaceholder}`)
                      }, _toDisplayString(__props.placeholder), 3))
                ]),
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(ArrowDownTableIcon, {
                    class: _normalizeClass('right-arrow-icon'),
                    color: __props.arrowColor
                  }, null, 8, ["color"])
                ])
              ]))
            : _createCommentVNode("", true),
          (props.type === 'multi-select')
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  (props.data.length === 0)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        class: _normalizeClass(`placeholder-container ${__props.classTextPlaceholder}`)
                      }, _toDisplayString(__props.placeholder), 3))
                    : _createCommentVNode("", true),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.data, (item) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: item.id,
                      class: "role tw-text-sm tw-font-medium tw-flex tw-items-center tw-px-[13px] tw-text-[#231F20]"
                    }, [
                      _createElementVNode("span", null, _toDisplayString(item.name), 1)
                    ]))
                  }), 128))
                ]),
                _createVNode(ArrowDownTableIcon, {
                  class: _normalizeClass('right-arrow-icon'),
                  color: __props.arrowColor
                }, null, 8, ["color"])
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      default: _withCtx(() => [
        _renderSlot(_ctx.$slots, "default")
      ]),
      _: 3
    }, 8, ["id", "modelValue", "class", "data-cy"]),
    _createVNode(_component_b_form_invalid_feedback, {
      class: _normalizeClass({ 'is-invalid': __props.validation.$error })
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(VRuntimeTemplate), {
          template: __props.validation?.$errors?.[0]?.$message
        }, null, 8, ["template"])
      ]),
      _: 1
    }, 8, ["class"])
  ], 64))
}
}

})